import { TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import { theme } from "../theme.js";

export default function RequirementDocument({ 
  id,
  documentType, 
  label,
  level = "optional",  // Default to optional if not provided
  onLevelChange,
  onDelete 
}) {
  const documentOptions = [
    { value: "medical_cert", label: "Certificat médical" },
    { value: "parental_auth", label: "Autorisation parentale" },
    { value: "liability_waiver", label: "Décharge de responsabilité" },
  ];

  const levelOptions = [
    { value: "optional", label: "Optionnel" },
    { value: "required", label: "Obligatoire" },
  ];

  const documentLabel = label || documentOptions.find(d => d.value === documentType)?.label || documentType;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <p style={styles.documentName}>{documentLabel}</p>
        </div>
        <button onClick={onDelete} style={styles.deleteBtn}>
          <TrashIcon style={{ width: "24px", height: "24px", color: theme.colors.textMuted }} />
        </button>
      </div>

      <div style={styles.levelSelector}>
        {levelOptions.map((option) => (
          <label key={option.value} style={styles.levelLabel}>
            <input
              type="radio"
              name={`level_${id}`}
              value={option.value}
              checked={level === option.value}
              onChange={(e) => onLevelChange(e.target.value)}
              style={styles.radio}
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "12px 16px",
    backgroundColor: "#f3f4f6",
    borderRadius: "6px",
    marginBottom: "8px",
    border: "1px solid #e5e7eb",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  documentName: {
    margin: "0",
    fontWeight: "600",
    fontSize: "14px",
    color: theme.colors.dark,
  },
  deleteBtn: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    padding: "4px 8px",
  },
  levelSelector: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "8px",
  },
  levelLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "13px",
    color: theme.colors.dark,
  },
  radio: {
    marginRight: "6px",
    cursor: "pointer",
    accentColor: theme.colors.dark,
  },
};
